export class VegobjekterStatisticsResponseGruppert {
    constructor(readonly antall: number, readonly lengde: number, readonly fylke: number) {}
}

export class VegobjekterStatisticsByKategoriResponseGruppert {
    constructor(readonly antall: number, readonly lengde: number, readonly vegkategori: string) {}
}

export class AllVegobjekterStatisticsResponseGruppert {
    constructor(
        readonly antall: number,
        readonly lengde: number,
        readonly vegkategori: string,
        readonly fylke: number,
        readonly kommune: number
    ) {}
}
